import React from 'react';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { linkview } from '../DashboardLinkWidget';

type Props = {
  className: string;
  title: string;
  description: string;
  avatar: string;
  link: string | undefined;
  crmClientId: number | undefined;
};

const SevaWidget: React.FC<Props> = ({ className, title, description, avatar, link, crmClientId }) => {
  return (
    <div style={{ padding: 0 }}>
      <div
        className={`hoverable`}
        role="button"
        onClick={() => linkview(link, title, () => {})}
        style={{ cursor: 'pointer' }}
      >
        {crmClientId === 188 ? (
          <img src={toAbsoluteUrl('/media/partner/cnh.png')} width="100%" alt='Seva' className='card-p-5 shadow' style={{ borderRadius: 8 }} />
        ) : (
          <img src={toAbsoluteUrl('/media/partner/seva.png')} width="100%" alt='Seva' className='card-p-5 shadow' style={{ borderRadius: 8 }} />
        )}
      </div>
    </div>
  );
};

export { SevaWidget };
